import type { MenuItem } from "@/components/menu/menu.props.ts"
import { Device } from "@/utils/device"
import { slugify } from "@/utils/slugify.ts"
import { webPath } from "@/utils/webPath"

interface ItemMenuChildProps {
    item: MenuItem
    device: number
    hostImagem: string
}

export function ItemsMenuChild({
   item,
   device,
   hostImagem
}: ItemMenuChildProps) {
    return (
        <div className="container-menu">
            <ul
                className={`menu-level-${item.nivel + 1} menu-child-${item.id}`}
            >
                {item.childs.length > 0 && item.childs.map((itemChild) => (
                    <li
                        key={itemChild.id}
                        className={`menu-list-${itemChild.id} ${itemChild.childs.length > 0 ? 'has-childs' : 'not-has-childs'} ${slugify(itemChild.nome)} item-menu-${slugify(itemChild.nome)}`}
                    >
                        <a  
                            href={webPath(itemChild.link)}
                            className={`menu-link-${itemChild.id} ${item.childs.length > 0 ? 'has-childs' : 'not-has-childs'}`}
                        >
                             <span
                                 className={`menu-icon ${!(itemChild.icone_midia_path && itemChild.icone_midia_arquivo_nome) && 'no-icon'}`}
                             >
                                {(device == Device.DESKTOP && itemChild.icone_midia_path && itemChild.icone_midia_arquivo_nome) && (
                                    <img
                                        className="h-auto"
                                        src={hostImagem + '/' + itemChild.icone_midia_path! + itemChild.icone_midia_arquivo_nome}
                                        alt={itemChild.icone_midia_path && itemChild.icone_midia_arquivo_nome}
                                    />
                                )}
                            </span>
                            <span className="menu-text" dangerouslySetInnerHTML={{__html: itemChild.nome}}/>
                        </a>

                        {(item.childs && item.childs.length > 0) && generateHtmlChild(itemChild)}
                    </li>
                ))}
            </ul>
        </div>
    )
}


function generateHtmlChild(menuItem: MenuItem) {
    if(!menuItem.childs) {
        return null
    }

    return (
        <div className="container-menu">
            <ul
                className={`menu-level-${menuItem.nivel + 1}`}
            >
                {menuItem.childs.map((menuItemChild) => (
                    <li
                        key={menuItemChild.id}
                        className={`menu-list-${menuItemChild.id} ${menuItemChild.childs && menuItemChild.childs.length > 0 ? 'has-childs' : 'not-has-childs'} ${slugify(menuItemChild.nome)} item-menu-${slugify(menuItemChild.nome)}`}
                    >
                        <a
                            href={webPath(menuItemChild.link)}
                            className={`menu-link-${menuItemChild.id} ${menuItemChild.childs && menuItemChild.childs.length > 0 ? 'has-childs' : 'not-has-childs'}`}
                        >
                            <span className="menu-text" dangerouslySetInnerHTML={{ __html: menuItemChild.nome }} />
                        </a>

                        {menuItemChild.childs && menuItemChild.childs.length > 0 && generateHtmlChild(menuItemChild)}
                    </li>
                ))}
            </ul>
        </div>
    )
}